import { ApiService, PublicService } from '@DavisDigital/davisdigitalfrontend.module';
import * as IDavis from '@DavisDigital/interfaces';

declare var angular;

export class ImageService {
	public imageMap: any;
	public imageMapDeferred: any;

	//@ngInject
	constructor(
		private $cacheFactory:	ng.ICacheFactoryService,
		private $http:			ng.IHttpService,
		private $q: 			ng.IQService,
		private apiService: 	ApiService,
		private publicService:  PublicService
	) { }

	public getImageDetails = ( imageID: string = '' ): ng.IPromise<IDavis.IImage> => {
		const data: IDavis.IImage = {
			imageID: imageID
		};

		const defer = this.$q.defer();
		
		this.apiService
			.request('davisdigital:api.getImage', data, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			})
			.catch( (reason: any) => {
				defer.reject( reason );
			});
		
		return defer.promise;
	}

	public getImages = (
		currentPage: number = 1, 
		pageSize: number = 20, 
		keywords: string = '', 
		k5appropriate: boolean = true, 
		sortBy: string = 'artistName',
		arrayImageIDs:string[]=[],
		arrayImageSetIDs: string[] = [],
		filterConfig:any = {},
		keywordConfig:any = {}
	): ng.IPromise<IDavis.ImageCollectionList> => {
		const apiData: IDavis.ImageCollectionList = {
			currentPage: currentPage,
			pageSize: pageSize,
			keywords: keywords,
			k5appropriate: k5appropriate,
			sortBy: sortBy,
			arrayImageIDs:arrayImageIDs,
			arrayImageSetIDs: arrayImageSetIDs,
			filterConfig: filterConfig,
			keywordConfig: keywordConfig
		};

		const defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.getImages', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			})
			.catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}

	public getImageSet = ( imageSetID: string = '' ): ng.IPromise<IDavis.ImageSetCollectionList> => {
		const apiData: IDavis.IImageSet = {
			imageSetID: imageSetID
		};

		const defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.getImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			})
			.catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}
	
	// What is this for?
	public getImageSetsForAccount = ( imageID: string ) =>{
		var data = {
			'imageID': imageID
		};
		
		var defer = this.$q.defer();
		
		this.apiService
			.request('davisdigital:api.getImageSetsForAccount', data, 'GET')
			.then( (response) => {
				if(response.data){
					defer.resolve(response.data);
				} else {
					defer.reject( response )
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});
		
		return defer.promise; 
	}

	public getImageSetImages = ( 
		imageSetID: string = '',
		currentPage: number = 1, 
		pageSize: number = 20, 
		keywords: string = '', 
		k5appropriate: boolean = true, 
		sortBy: string = 'artistName',
		slideShowforAllImages:boolean=false,
	): ng.IPromise<IDavis.ImageCollectionList> => {
		const apiData: IDavis.ImageCollectionList = {
			imageSetID: imageSetID,
			currentPage: currentPage,
			pageSize: pageSize,
			keywords: keywords,
			k5appropriate: k5appropriate,
			sortBy: sortBy,
			slideShowforAllImages:slideShowforAllImages,
		};

		const defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.getImageSetImages', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			})
			.catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}


	public getImageSets = (
		currentPage: number = 1, 
		pageSize: number = 20, 
		keywords: string = '', 
		k5appropriate: boolean = true,
		arrayImageIDs: string[] = [],
		sortBy: string = 'title',
		allRecords: boolean = false,
		selectedTab: string = "mycollections",
		sharedWithTeacher: boolean = true,
		sharedWithStudent: boolean = true,
		superUser: boolean = false,
	): ng.IPromise<IDavis.ImageSetCollectionList> => {
		const apiData: IDavis.ImageSetCollectionList = {
			currentPage: currentPage,
			pageSize: 20, //do not allow override
			keywords: keywords,
			k5appropriate: superUser ? false : k5appropriate,
			arrayImageIDs: arrayImageIDs,
			sortBy: sortBy,
			allRecords: allRecords,
		};
		
		if ( selectedTab == 'mycollections' && superUser === false) {
			apiData.myCollectionsOnly = true;
		} else if (selectedTab == 'daviscollections') {
			apiData.davisCollectionsOnly = true;
		} else if (selectedTab == 'bookcollections') {
			apiData.bookCollectionsOnly = true;
		} else if (selectedTab == 'sharedcollections') {
			apiData.sharedCollectionsOnly = true;
			
			apiData.sharedWithTeacher = sharedWithTeacher;
			apiData.sharedWithStudent = sharedWithStudent;
		}
		
		const defer = this.$q.defer();
		
		this.apiService
			.request('davisdigital:api.getImageSets', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			})
			.catch( (reason: any) => {
				defer.reject( reason ) ;	
			});
		
		return defer.promise;
	}
	
	public getImageSetsForImage = (image) =>{
		
		var apiData = {
			imageID: image.imageID
		}
		
		const defer = this.$q.defer();
		
		this.apiService
			.request('davisdigital:api.getImageSetsForImage', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.data.success ) {
					defer.resolve( value.data.data.records );
				} else {
					defer.reject( value );
				}
			})
			.catch( (reason: any) => {
				defer.reject( reason ) ;	
			});
		
		return defer.promise;
	}

	public saveImageSet = ( imageSet: IDavis.IImageSet ): ng.IPromise<IDavis.IImageSet> => {
		const defer = this.$q.defer();
		const apiData = imageSet;

		this.apiService
			.request('davisdigital:api.saveImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}
	
	public saveImageSets = ( imageSets: any[], arrayImageIDs: any[]) =>{
		const defer = this.$q.defer();
		const apiData = {
			imageSets: imageSets, 
			imageIDs: arrayImageIDs
		}; 

		this.apiService
			.request('davisdigital:api.saveImageSets', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	
	}
	
	public copyImageSet = ( imageSet: IDavis.IImageSet): ng.IPromise<IDavis.IImageSet> => {
		const defer = this.$q.defer();
		const apiData = imageSet;
		
		this.apiService
			.request('davisdigital:api.copyImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}

	public saveImageSortOrderForImageSet = ( imageSetID: string, reorderedImageSetImages: any[]) =>{
		const defer = this.$q.defer();
		const apiData = {
			imageSetID : imageSetID, 
			imageSetImages : reorderedImageSetImages
		};

		this.apiService
			.request('davisdigital:api.saveImageSortOrderForImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}

	public deleteImageSet = ( imageSetID: string = '' ): ng.IPromise<any> => {
		const apiData: IDavis.IImageSet = {
			imageSetID: imageSetID
		};

		const defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.deleteImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}
	
	public addImageToImageSet = ( imageID, imageSetID ) =>{
		
		let apiData: any = {
			imageID: imageID,
			imageSetID: imageSetID
		};

		let defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.addImageToImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}
	
	public removeImageFromImageSet = ( imageID, imageSetID ) =>{
		
		let apiData: any = {
			imageID: imageID,
			imageSetID: imageSetID
		};

		let defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.removeImageSetImageFromImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}
	
	public removeImagesFromImageSet = (imageIDs, imageSetID) =>{
		let apiData: any = {
			imageIDs: imageIDs,
			imageSetID: imageSetID
		};

		let defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.removeImageSetImagesFromImageSet', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}
	
	public getPageImagesForBook = ( bookID: string ) => {
		
		let apiData: any = {
			'bookID': bookID
		};

		let defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.getPageImagesForBook', apiData, 'POST', false)
			.then( (response ) => {
			    
				if ( !response.data?.data?.pageImageMap ){
					throw( response.data );
				}
				
				defer.resolve( response.data.data );
			})
			.catch( defer.reject );

		return defer.promise;
	}
	
	/**
	 * Save PageNote
	 * Either update or add a new page note depending on if a pageNoteID was provided.
	 *
	 * @param {any} data - pageNotes data formatted for the PageNote entity
	 * @return {Promise<any>} API Response depending on slatAction
	 */
	public savePageImageNote = ( data: { pageImageID ?: string, pageImageNoteID ?: string, note: string} ) : ng.IPromise<IDavis.PageImageNote> => {

		let deferred = this.$q.defer<IDavis.PageImageNote>();

		let action = 'addPageImageNote';

		// Update the pageImageNote if an ID is defined
		if ( data.pageImageNoteID?.trim?.() ){
			action = 'updatePageImageNote';
		}

		this.apiService.request( `davisdigital:api.${action}`, data )
	    .then( result => {
		    if( !result.data.data?.pageImageNote || !result.data?.successfulActions?.includes?.(action) ){
		        throw(result.data);
		    }
		    
		    let note = result.data.data.pageImageNote;
	        note.createdDateTime = Date.parse(note?.createdDateTime);
			note.modifiedDateTime = Date.parse(note?.modifiedDateTime);	    
			
			deferred.resolve( note );
		})
		.catch( result => {
			deferred.reject( result );
		});

		return deferred.promise;
	}

	/**
	 * Delete Note
	 *
	 * @param {string} pageImageNoteID - ID of the pageNote to be deleted
	 * @return {Promise<any>} successful & failure actions
	 */
	public deleteNote = ( pageImageNoteID: string ) => {

		let deferred = this.$q.defer<IDavis.IResponse<any>>();
		
		let data = {
			pageImageNoteID: pageImageNoteID
		}

		this.apiService.request( 'davisdigital:api.deletePageImageNote', data )
		.then( result => {
		    
		    if(!result.data.data?.success){
		        throw(result.data);
		    }
		    
			deferred.resolve( result.data.data?.success );
		})
		.catch( deferred.reject );

		return deferred.promise;
	}
	
	/* Gets pageNotes by page and bookID
	 *
	 * @async
	 * @param {string} pageImageID - Unique identifier for a page-image.
	 * @return {Promise<Array<IDavis.PageImageNote>>} Array of pageNotes for the provided pageImageID.
	 */
	public getPageImageNotesForPageImage = ( pageImageID: string ): ng.IPromise<Array<IDavis.PageImageNote>> => {

		let deferred = this.$q.defer<Array<IDavis.PageImageNote>>();

		let data = {
			pageImageID: pageImageID
		};

	    this.apiService.request( 'davisdigital:api.getPageImageNotesForPageImage', data )
	    .then( result => {
	        
	        if( result.data.data?.pageImageNotes){
	            throw(result.data);
	        }
	        
			let notes = result.data.data.pageImageNotes.map( note => {
				note.createdDateTime = Date.parse(note.createdDateTime)
				note.modifiedDateTime = Date.parse(note.modifiedDateTime)
			});
			
			deferred.resolve( notes );
		})
		.catch( result => {
			deferred.reject( result );
		});
		
		return deferred.promise;
	}

	public setImageMap = ( imageMap: any ): ng.IPromise<any> => {
		
		this.imageMapDeferred = this.$q.defer();
		
		if(imageMap == null){
			this.imageMapDeferred.promise;	
		}
		
		if(this.imageMap == null ){
			this.imageMap = imageMap;
		} else {
			for(var key in imageMap){
				this.imageMap[key] = imageMap[key];
			}	
		}
		
		this.imageMapDeferred.resolve(this.imageMap);
		
		return this.imageMapDeferred.promise;
	}

	public getImageMap = (): ng.IPromise<any> =>{
		return this.imageMapDeferred.promise;
	}

	public getImage = ( imageID: string ):any => {
		
		if(!this.imageMap){
			return;
		}
		
		if(!(imageID in this.imageMap)){
			return;
		}
		
		return this.imageMap[imageID];
	}
	
	public getFilterOptions = () =>{
		const defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.getImageFilterOptions')
			.then( (response: any) => {
				
				if(response.data?.data){
					defer.resolve( response.data.data );
				} else {
					defer.reject( 'Data not returned' );
				}
			
			}).catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;	
	}
	
	private clearEndpointCache = ( endpoint: string ):void => {
		var httpCache = this.$cacheFactory.get('$http');
			httpCache.remove(endpoint);
	}
	
	public uploadImageToContentModuleImage = ( imageBlob: string | Blob, contentModuleImage: any ) =>{
		var formData = new FormData();

		formData.append( "imageBlob", imageBlob);
		formData.append( "contentModuleImage", angular.toJson(contentModuleImage) );
		
		var endpoint = 'davisdigital:api.uploadImageToContentModuleImage';
		
		this.clearEndpointCache(endpoint);
		
		return this.$http.post(
			this.apiService.getEndpoint(endpoint),
			formData,
			{
				headers: { 'Content-Type': undefined },
        		transformRequest: angular.identity
			}
		)
	}

	public uploadImageToContentModule = ( files: any, contentModule: any, entityId: string, entityName: string ) => {
		var formData = new FormData();
		for(var i=0; i<files.length; i++){
			formData.append( "imageFile[" + (i+1) + "]", files[i]);
		}
		formData.append( "contentModule", angular.toJson(contentModule) );
		formData.append( entityName + "ID", entityId);
		
		var endpoint = 'davisdigital:api.uploadImageToContentModule'
		
		this.clearEndpointCache(endpoint);

		return this.$http.post(
			this.apiService.getEndpoint(endpoint),
			formData,
			{
				headers: { 'Content-Type': undefined },
        		transformRequest: angular.identity
			}
		)
	}
	
	/**
     * Method to update share settings for portfolio
     * */
    public imageCollectionShare(imageSetID: string, sharedWithStudent: boolean, sharedWithTeacher: boolean, sharedAsDavisCollection: boolean,sharedAsBookCollection: boolean ): ng.IPromise<any> {
        let deferred = this.$q.defer();
		
		this.apiService.request(
		    'davisdigital:api.imageCollectionShareSettings', 
			{ 
				imageSetID: imageSetID,
				sharedWithStudent: sharedWithStudent, 
				sharedWithTeacher: sharedWithTeacher,
				sharedAsDavisCollection: sharedAsDavisCollection,
				sharedAsBookCollection: sharedAsBookCollection
			},
			'POST'
		)
		.then((result) => {
			deferred.resolve(result.data);
		})
		.catch((result) => {
			deferred.reject(result);
		});

		return deferred.promise;
    }
    
    public getAllImageSetImages = ( 
		imageSetID: string = '',
		currentPage: number = 1, 
		pageSize: number = 20, 
		keywords: string = '', 
		k5appropriate: boolean = true, 
		sortBy: string = 'artistName'
	): ng.IPromise<IDavis.ImageCollectionList> => {
		const apiData: IDavis.ImageCollectionList = {
			imageSetID: imageSetID,
			currentPage: currentPage,
			pageSize: pageSize,
			keywords: keywords,
			k5appropriate: k5appropriate,
			sortBy: sortBy,
		};

		const defer = this.$q.defer();

		this.apiService
			.request('davisdigital:api.getAllImageSetImages', apiData, 'POST', false)
			.then( (value: any) => {
				if ( value.data.success ) {
					defer.resolve( value.data.data );
				} else {
					defer.reject( value );
				}
			})
			.catch( (reason: any) => {
				defer.reject( reason );
			});

		return defer.promise;
	}

}
